import { useEffect, useState } from "react";
import DashboardGreeting from "../DashboardGreeting";
import SearchIcon from "../../assets/images/search.svg";
import moment from "moment";
import FilterIcon from "../../assets/images/filter.svg";
import ExportIcon from "../../assets/images/export.svg";
import { useStateContext } from "../../contexts/ContextProvider";
import LeaveRequestFilterModal from "../common/LeaveRequestFilterModal";
import TimeIcon from "../../assets/images/time.svg";
import GreenCheck from "../../assets/images/greenCheck.svg";
import RedCross from "../../assets/images/close-circle.svg";
import { Link, useLocation } from "react-router-dom";
import DashedArrow from "../../assets/images/dashed-arrow.svg";
import PartiallyApprovedDashedArrow from "../../assets/images/partiallyApprovedDashedArrow.svg";
import ApprovedDashedArrow from "../../assets/images/approvedDashedArrow.svg";
import partiallyRejectedDashedArrow from "../../assets/images/partiallyRejectedDashedArrow.svg";
import RejectedDashedArrow from "../../assets/images/rejectedDashedArrow.svg";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import DataTableComponent from "../Charts/DatatableComponent";
import ProbationCircle from "../../assets/images/probationCircle.svg";
import FullTimeCircle from "../../assets/images/fullTimeCircle.svg";
import ApproveRequest from "./ApproveRequest";
import RejectRequest from "./RejectRequest";
import LeaveHistoryService from "../../services/leaveHistory.service";
import Success from "../common/CustomModals/Success";

import * as XLSX from "xlsx";
import EditRequest from "./EditRequest";
import RevokeRequest from "./RevokeRequest";
import { Empty, Skeleton } from "antd";

const LeaveRequest = ({ user }) => {
  const navHeading = "Leaves Request";
  const location = useLocation();
  const [tabIndex, setTabIndex] = useState(
    location && location.state ? location.state.redirectIndex : 0,
  );
  const [allData, setAllData] = useState([]);
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [data3, setData3] = useState([]);
  const [newData, setNewData] = useState([]);

  const [loading, setLoading] = useState(false);

  const leaveData =
    tabIndex === 0
      ? allData
      : tabIndex === 1
        ? data
        : tabIndex === 2
          ? data2
          : tabIndex === 3
            ? data3
            : newData;
  const {
    filterBy,
    setFilterBy,
    showCalendar,
    setShowCalendar,
    approveModal,
    setApproveModal,
    rejectModal,
    setRejectModal,
    success,
    setSuccess,
  } = useStateContext();

  const [editModal, setEditModal] = useState(false);
  const [revokeModal, setRevokeModal] = useState(false);

  // const currentDate = new Date();

  const initialData = {
    empId: null,
    leaveReason: "",
    date: "",
    formatedDate: "",
    leaveDays: "",
    isProbation: "",
  };

  const [details, setDetails] = useState(initialData);

  const [date, setDate] = useState();
  const [checked, setChecked] = useState("");

  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const [leaveDays, setLeaveDays] = useState({});

  const [selectedRowData, setSelectedRowData] = useState({});

  const [heading, setHeading] = useState("");

  const handleCheckedChange = (type) => (e) => {
    if (e.target.checked) {
      setChecked(type);
      setDetails((prev) => ({
        ...prev,
        isProbation: type,
      }));
    } else {
      setChecked("");
    }
  };

  const fetchWeekendHolidaysList = (selectedData) => {
    const fromDate = selectedData.fromDate;
    const toDate = selectedData.toDate;
    const fDatehalfday = selectedData.fDatehalfday;
    const tDatehalfday = selectedData.tDatehalfday;
    const payload = {
      fromdate: moment(fromDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
      todate: moment(toDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
      sHsts: fDatehalfday,
      eHsts: tDatehalfday,
    };
    LeaveHistoryService.getWeekendHolidaysList(payload)
      .then((resp) => {
        const data = resp.data.filter((item, index) => index !== 0);
        setLeaveDays(data);
      })
      .catch((e) => console.log(e));
  };

  const fetchLeaveRequest = () => {
    const payload = {
      emp_id: "",
    };

    setLoading(true);

    LeaveHistoryService.getLeaveRequest(payload)
      .then((response) => {
        if (response.data) {
          const apiData = response.data;
          const newData = apiData.filter(
            (item) => item.rmActionsts === "0" && item.hrActionsts === "0",
          );
          const pending = apiData.filter(
            (item) => item.rmActionsts === "1" && item.hrActionsts === "0",
          );
          const approved = apiData.filter((item) => item.hrActionsts === "1");
          const rejected = apiData.filter(
            (item) => item.rmActionsts === "2" || item.hrActionsts === "2",
          );
          setLoading(false);
          setAllData(apiData);
          setData(pending);
          setData2(approved);
          setData3(rejected);
          setNewData(newData);
        }
      })
      .catch((e) => console.log(e));
  };

  const fetchTeamLRequest = () => {
    const payload = {
      rmid: user.role === "2" ? user.empid : "",
    };

    setLoading(true);

    LeaveHistoryService.getTeamLRequest(payload)
      .then((response) => {
        if (response.data) {
          const pending = response.data.filter(
            (item) =>
              (item.rmActionsts === "0" && item.hrActionsts === "0") ||
              (item.rmActionsts === "1" && item.hrActionsts === "0"),
          );
          const approved = response.data.filter(
            (item) => item.hrActionsts === "1",
          );
          const rejected = response.data.filter(
            (item) => item.rmActionsts === "2" || item.hrActionsts === "2",
          );
          setLoading(false);
          setAllData(response.data);
          setData(pending);
          setData2(approved);
          setData3(rejected);
        }
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    if (user.role === "1" || user.role === "4") {
      fetchLeaveRequest();
    } else {
      fetchTeamLRequest();
    }
  }, [user]);

  const showFilter = (e) => {
    e.preventDefault();
    setFilterBy(true);
  };

  const ShowCalendar = (e) => {
    e.preventDefault();
    setShowCalendar(true);
  };

  const columns = [
    {
      name: "Emp Id",
      selector: (row) => row.emp_id,
      omit: true,
    },
    {
      name: "Emp Name",
      selector: (row) => row.empName,
      cell: (row) => (
        <>
          <div className="emp-info">
            <span>
              <img
                src={row.isProbation === "1" ? ProbationCircle : FullTimeCircle}
                alt=""
              />
            </span>
            <span>
              <svg
                width="17"
                height="17"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.9993 0C8.50756 0 6.48047 2.02709 6.48047 4.51881C6.48047 7.01052 8.50756 9.03762 10.9993 9.03762C13.491 9.03762 15.5181 7.01052 15.5181 4.51881C15.5181 2.02709 13.491 0 10.9993 0ZM10.9993 6.87723C9.69878 6.87723 8.64085 5.8193 8.64085 4.51881C8.64085 3.21832 9.69878 2.16038 10.9993 2.16038C12.2998 2.16038 13.3577 3.21832 13.3577 4.51881C13.3577 5.8193 12.2998 6.87723 10.9993 6.87723Z"
                  fill="#4E465E"
                />
                <path
                  d="M11.0002 11.198C6.43383 11.198 2.71875 14.9131 2.71875 19.4795C2.71875 20.0761 3.20241 20.5597 3.79894 20.5597H9.92005V20.9198C9.92005 21.5163 10.4037 22 11.0002 22C11.5968 22 12.0804 21.5163 12.0804 20.9198V20.5597H18.2016C18.7981 20.5597 19.2817 20.076 19.2817 19.4795C19.2817 14.9131 15.5667 11.198 11.0002 11.198ZM9.92005 18.3993H4.97457C5.42359 15.8883 7.40913 13.9032 9.92005 13.4543V18.3993ZM12.0804 18.3993V13.4543C14.5914 13.9032 16.5769 15.8883 17.0259 18.3993H12.0804V18.3993Z"
                  fill="#4E465E"
                />
              </svg>
            </span>
            <div className="flex-column">
              <span>{row.empName}</span>
              <span className="code">ID: {row.emp_id}</span>
            </div>
            <div className="leave-details">
              <div className="profiles">
                <div className="profile">
                  <span className="name">{row.managerName}</span>
                  <span className="desig">TL</span>
                </div>
                <div className="icon flex-row gap-2">
                  {row.rmActionsts === "0" ? (
                    <>
                      <span>
                        <img src={TimeIcon} alt="" />
                      </span>
                    </>
                  ) : row.rmActionsts === "1" ? (
                    <>
                      <span>
                        <img src={GreenCheck} alt="" />
                      </span>
                    </>
                  ) : row.rmActionsts === "2" ? (
                    <>
                      <span>
                        <img src={RedCross} width={20} alt="" />
                      </span>
                    </>
                  ) : null}

                  {row.rmActionsts === "0" && row.hrActionsts === "0" ? (
                    <>
                      <span className="">
                        <img src={DashedArrow} width={125} alt="" />
                      </span>
                    </>
                  ) : row.rmActionsts === "1" && row.hrActionsts === "0" ? (
                    <>
                      <div className="process-flex">
                        <span className="">
                          <img
                            src={PartiallyApprovedDashedArrow}
                            width={125}
                            alt=""
                          />
                        </span>
                      </div>
                    </>
                  ) : row.rmActionsts === "1" || row.hrActionsts === "1" ? (
                    <>
                      <span className="">
                        <img src={ApprovedDashedArrow} width={125} alt="" />
                      </span>
                    </>
                  ) : row.rmActionsts === "2" ? (
                    <>
                      <span>
                        <img
                          src={partiallyRejectedDashedArrow}
                          width={125}
                          alt=""
                        />
                      </span>
                    </>
                  ) : row.hrActionsts === "2" ? (
                    <>
                      <span>
                        <img src={RejectedDashedArrow} width={125} alt="" />
                      </span>
                    </>
                  ) : null}

                  {row.hrActionsts === "0" ? (
                    <>
                      <span>
                        <img src={TimeIcon} alt="" />
                      </span>
                    </>
                  ) : row.hrActionsts === "1" ? (
                    <>
                      <span>
                        <img src={GreenCheck} alt="" />
                      </span>
                    </>
                  ) : row.hrActionsts === "2" ? (
                    <>
                      <span>
                        <img src={RedCross} alt="" />
                      </span>
                    </>
                  ) : null}
                </div>
                <div className="profile">
                  <span className="name">Sapna Sonwani</span>
                  <span className="desig">HR</span>
                </div>
              </div>
              <div className="profiles">
                <div className="profile">
                  <span className="name">Applied On</span>
                  <span className="desig">{row.requstOn}</span>
                </div>
              </div>
              {user.role !== "2" && row.rmActionsts !== "0" ? (
                <>
                  <div className="profiles">
                    <div className="profile">
                      <span className="name">
                        {row.rmActionsts === "1"
                          ? "Approved By RM"
                          : row.rmActionsts === "2"
                            ? "Rejected By RM"
                            : ""}
                      </span>
                      <span className="desig">{row.rmActionOn}</span>
                    </div>
                  </div>
                </>
              ) : null}
              {row.hrActionsts !== "0" ? (
                <>
                  <div className="profiles">
                    <div className="profile">
                      <span className="name">
                        {row.hrActionsts === "1"
                          ? "Approved By HR"
                          : row.hrActionsts === "2"
                            ? "Rejected By HR"
                            : ""}
                      </span>
                      <span className="desig">{row.hrActionOn}</span>
                    </div>
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Leave Reason",
      selector: (row) => row.leaveReason,
      cell: (row) => {
        return (
          <>
            <div className="leave-rquest">
              <span title={`${row.leaveReason}`}>{`${row.leaveReason}`}</span>
            </div>
          </>
        );
      },
      sortable: true,
      width: "150px",
    },
    {
      name: "From",
      selector: (row) => row.fromDate,
      cell: (row) => {
        return (
          <>
            <span title={`${row.fromDate}`}>{row.fromDate}</span>
          </>
        );
      },
      sortable: true,
    },
    {
      name: "To",
      selector: (row) => row.toDate,
      cell: (row) => {
        return (
          <>
            <span title={`${row.toDate}`}>{row.toDate}</span>
          </>
        );
      },
      sortable: true,
    },
    {
      name: "Leave Days",
      selector: (row) => row.leavedays,
      cell: (row) => (
        <>
          <span title={`${row.leavedays}`}>{`${row.leavedays}`}</span>
        </>
      ),
      sortable: true,
      width: "85px",
    },
    {
      name: "Date of Return",
      selector: (row) => row.dor,
      cell: (row) => (
        <>
          <span title={`${row.dor}`}>{`${row.dor}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "View Details",
      // selector: (row) => row.description?.replaceAll(/<br\s*\/?>/gi, " "),
      selector: (row) => {
        let text = row.description || "";

        // Remove <br>, <br/>, <br />
        text = text.replace(/<br\s*\/?>/gi, " ");

        // Remove ALL HTML tags (optional but usually needed)
        text = text.replace(/<[^>]+>/g, " ");

        // Convert &amp; → &
        text = text.replace(/&amp;/g, "&");

        // Remove extra spaces (multiple → single)
        text = text.replace(/\s+/g, " ").trim();

        return text;
      },
      cell: (row) => (
        <>
          <Link
            to={"/empLeaveDetails"}
            state={{ rowData: row, redirectBack: "/leaveRequest" }}
          >
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-eye"
                viewBox="0 0 16 16"
              >
                <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
              </svg>
            </span>
          </Link>
        </>
      ),
      sortable: true,
    },
    {
      name: "RM Approval",
      selector: (row) => row.rmActionsts,
      cell: (row) => {
        const rmActionsts = row.rmActionsts;
        return (
          <>
            <div
              className={`${
                rmActionsts === "0" || rmActionsts === "Pending"
                  ? "status pending"
                  : rmActionsts === "1" || rmActionsts === "Accept"
                    ? "status approved"
                    : "status rejected"
              }`}
            >
              <span
                title={`${
                  rmActionsts === "0"
                    ? "Pending" || rmActionsts === "Pending"
                    : rmActionsts === "1" || rmActionsts === "Accept"
                      ? "Approved"
                      : "Rejected"
                }`}
              >{`${
                rmActionsts === "0" || rmActionsts === "Pending"
                  ? "Pending"
                  : rmActionsts === "1" || rmActionsts === "Accept"
                    ? "Approved"
                    : "Rejected"
              }`}</span>
            </div>
          </>
        );
      },
      sortable: true,
      width: "110px",
    },
    {
      name: "HR Approval",
      selector: (row) => row.rmActionsts,
      cell: (row) => (
        <>
          <div
            className={`${
              row.hrActionsts === "0"
                ? "status pending"
                : row.hrActionsts === "1"
                  ? "status approved"
                  : "status rejected"
            }`}
          >
            <span
              title={`${
                row.hrActionsts === "0"
                  ? "Pending"
                  : row.hrActionsts === "1"
                    ? "Approved"
                    : "Rejected"
              }`}
            >{`${
              row.hrActionsts === "0"
                ? "Pending"
                : row.hrActionsts === "1"
                  ? "Approved"
                  : "Rejected"
            }`}</span>
          </div>
        </>
      ),
      sortable: true,
      width: "110px",
      // omit: user.role !== "1",
    },
    {
      name: "Action",
      selector: (row) => row.leaveStatus,
      cell: (row) => (
        <>
          {(user.role === "2" && row.rmActionsts === "0") ||
          (user.role === "1" && row.hrActionsts === "0") ? (
            <>
              <div className="action">
                <button
                  className="approve"
                  onClick={(e) => {
                    setApproveModal(true);
                    fetchWeekendHolidaysList(row);
                    setSelectedRowData(row);
                  }}
                >
                  Approve
                </button>
                <button
                  className="reject"
                  onClick={(e) => {
                    setRejectModal(true);
                    fetchWeekendHolidaysList(row);
                    setSelectedRowData(row);
                  }}
                >
                  Reject
                </button>
              </div>
            </>
          ) : row.rmActionsts === "0" &&
            row.hrActionsts === "0" &&
            row.managerName.includes("Leena Joseph") ? (
            <>
              <div className="action">
                <button
                  className="approve"
                  onClick={(e) => {
                    setApproveModal(true);
                    fetchWeekendHolidaysList(row);
                    setSelectedRowData(row);
                  }}
                >
                  Approve
                </button>
                <button
                  className="reject"
                  onClick={(e) => {
                    setRejectModal(true);
                    fetchWeekendHolidaysList(row);
                    setSelectedRowData(row);
                  }}
                >
                  Reject
                </button>
              </div>
            </>
          ) : (
            <>
              ----
              {/* <div className="action">
                <button
                  className="edit"
                  onClick={(e) => {
                    setEditModal(true);
                    fetchWeekendHolidaysList(row);
                    setSelectedRowData(row);
                  }}
                >
                  Edit
                </button>
                <button
                  className="reject"
                  onClick={(e) => {
                    setRevokeModal(true);
                    fetchWeekendHolidaysList(row);
                    setSelectedRowData(row);
                  }}
                >
                  Revoke
                </button>
              </div> */}
            </>
          )}
        </>
      ),
      sortable: true,
      width: "175px",
      omitFromExport: true,
      omit: leaveData.every(
        (row) =>
          (row.leaveStatus && row.hrActionsts !== "0") ||
          (row.status && row.status !== "Pending") ||
          row.rmActionsts === "2" ||
          row.hrActionsts === "2",
      ),
    },
  ];

  const handleSearch = (e) => {
    const keyword = e.target.value.toLowerCase();
    setSearch(e.target.value);
    const filteredData = leaveData.filter(
      (row) =>
        (row.empName && row.empName.toLowerCase().includes(keyword)) ||
        (row.name && row.name.toLowerCase().includes(keyword)) ||
        (row.emp_id && row.emp_id.toLowerCase().includes(keyword)),
    );
    if (keyword.length > 0) {
      setFilter(true);
    } else {
      setFilter(false);
    }
    setFilteredData(filteredData);
  };

  const handleFilter = () => {
    let filteredData =
      tabIndex === 0
        ? allData
        : tabIndex === 1
          ? data
          : tabIndex === 2
            ? data2
            : tabIndex === 3
              ? data3
              : newData;

    // console.log("Filter Details: ", details);

    const objectValues = {
      emp_id: details.empId,
      leaveReason: details.leaveReason,
      requstOn: details.date,
      isProbation: details.isProbation,
      leavedays:
        details.leaveDays !== ""
          ? parseFloat(details.leaveDays).toFixed(2)
          : "",
    };

    const nonEmptyDetails = Object.fromEntries(
      Object.entries(objectValues).filter(
        ([_, value]) => value !== "" && value !== null,
      ),
    );

    filteredData = filteredData.filter((item) =>
      Object.entries(nonEmptyDetails).every(
        ([detailsKey, value]) => item[detailsKey] === value,
      ),
    );

    // console.log(nonEmptyDetails, filteredData);

    setFilter(true);
    setFilteredData(filteredData);
    setFilterBy(false);
  };

  const clearFilter = () => {
    setFilter(false);
    setDetails(initialData);
    setDate();
    setChecked("");
    setFilterBy(false);
  };

  const exportToExcel = (e, columns, data, reportName) => {
    const formattedData = data.map((row) => {
      const formattedRow = {};

      columns.forEach((col) => {
        let value;

        if (col.omitFromExport) return;

        // If selector exists
        if (typeof col.selector === "function") {
          value = col.selector(row);

          // Convert JSX / React element to text
          if (col.name === "RM Approval" || col.exportAsText) {
            value =
              row.rmActionsts === "0"
                ? "Pending"
                : row.rmActionsts === "1"
                  ? "Approved"
                  : "Rejected";
          } else if (col.name === "HR Approval" || col.exportAsText) {
            value =
              row.hrActionsts === "0"
                ? "Pending"
                : row.hrActionsts === "1"
                  ? "Approved"
                  : "Rejected";
          }
        } else {
          value = row[col.name];
        }

        formattedRow[col.name] = value;
      });

      return formattedRow;
    });

    const fileName = filter ? "" : "";

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `${reportName}.xlsx`);
  };

  return (
    <>
      <div className="dashboard-container hr">
        <DashboardGreeting navHeading={navHeading} user={user} />
        <Tabs
          selectedIndex={tabIndex}
          // selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}
        >
          <div className="filterBarNew">
            <div className="d-flex">
              <div className="searchBar">
                <input
                  type="text"
                  placeholder="Search Employee name/ID"
                  value={search}
                  onChange={handleSearch}
                />
                <span>
                  <img src={SearchIcon} alt="" />
                </span>
              </div>
              <div className="statusTabs">
                <TabList>
                  <Tab
                    className={
                      tabIndex === 0
                        ? "react-tabs__tab active"
                        : "react-tabs__tab"
                    }
                    onClick={() => setTabIndex(0)}
                  >
                    All - {allData.length}
                  </Tab>
                  <Tab
                    className={
                      tabIndex === 4
                        ? "react-tabs__tab active"
                        : "react-tabs__tab"
                    }
                    onClick={() => setTabIndex(4)}
                  >
                    New - {newData.length}
                  </Tab>
                  <Tab
                    className={
                      tabIndex === 1
                        ? "react-tabs__tab active"
                        : "react-tabs__tab"
                    }
                    onClick={() => setTabIndex(1)}
                  >
                    Pending - {data.length}
                  </Tab>
                  <Tab
                    className={
                      tabIndex === 2
                        ? "react-tabs__tab active"
                        : "react-tabs__tab"
                    }
                    onClick={() => setTabIndex(2)}
                  >
                    Approved - {data2.length}
                  </Tab>
                  <Tab
                    className={
                      tabIndex === 3
                        ? "react-tabs__tab active"
                        : "react-tabs__tab"
                    }
                    onClick={() => setTabIndex(3)}
                  >
                    Rejected - {data3.length}
                  </Tab>
                </TabList>
              </div>
            </div>

            <div className="filter topbar">
              <div className="sort-filter filter">
                <div className="filter" onClick={showFilter}>
                  <img src={FilterIcon} alt="" />
                </div>
                <div
                  className="export"
                  onClick={(e) => {
                    exportToExcel(
                      e,
                      columns,
                      filter ? filteredData : leaveData,
                      "Leave Applications",
                    );
                  }}
                >
                  <span>
                    <img src={ExportIcon} alt="" />
                  </span>
                  <span>Export</span>
                </div>
              </div>
            </div>
          </div>
          <div className="scroll">
            <TabPanel>
              <div className="">
                {loading ? (
                  <>
                    <Skeleton active={loading} />
                  </>
                ) : (filter ? filteredData : leaveData).length === 0 ? (
                  <>
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </>
                ) : (
                  <>
                    <DataTableComponent
                      columns={columns}
                      data={filter ? filteredData : leaveData}
                    />
                  </>
                )}
              </div>
            </TabPanel>
            <TabPanel>
              <div className="">
                {loading ? (
                  <>
                    <Skeleton active={loading} />
                  </>
                ) : (filter ? filteredData : leaveData).length === 0 ? (
                  <>
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </>
                ) : (
                  <>
                    <DataTableComponent
                      columns={columns}
                      data={filter ? filteredData : leaveData}
                    />
                  </>
                )}
              </div>
            </TabPanel>
            <TabPanel>
              <div className="">
                {loading ? (
                  <>
                    <Skeleton active={loading} />
                  </>
                ) : (filter ? filteredData : leaveData).length === 0 ? (
                  <>
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </>
                ) : (
                  <>
                    <DataTableComponent
                      columns={columns}
                      data={filter ? filteredData : leaveData}
                    />
                  </>
                )}
              </div>
            </TabPanel>
            <TabPanel>
              <div className="">
                {loading ? (
                  <>
                    <Skeleton active={loading} />
                  </>
                ) : (filter ? filteredData : leaveData).length === 0 ? (
                  <>
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </>
                ) : (
                  <>
                    <DataTableComponent
                      columns={columns}
                      data={filter ? filteredData : leaveData}
                    />
                  </>
                )}
              </div>
            </TabPanel>
            <TabPanel>
              <div className="">
                {loading ? (
                  <>
                    <Skeleton active={loading} />
                  </>
                ) : (filter ? filteredData : leaveData).length === 0 ? (
                  <>
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </>
                ) : (
                  <>
                    <DataTableComponent
                      columns={columns}
                      data={filter ? filteredData : leaveData}
                    />
                  </>
                )}
              </div>
            </TabPanel>
          </div>
        </Tabs>

        <div
          className={`${showCalendar ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setShowCalendar(false);
          }}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          ></div>
        </div>

        <div
          className={`${filterBy ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setFilterBy(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <LeaveRequestFilterModal
              details={details}
              setDetails={setDetails}
              tabIndex={tabIndex}
              handleFilter={handleFilter}
              clearFilter={clearFilter}
              date={date}
              setDate={setDate}
              checked={checked}
              handleCheckedChange={handleCheckedChange}
            />
          </div>
        </div>

        <div
          className={`${approveModal ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setApproveModal(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <ApproveRequest
              leaveDays={leaveDays}
              selectedRowData={selectedRowData}
              setSuccess={setSuccess}
              fetchData={
                user.role === "1" || user.role === "4"
                  ? fetchLeaveRequest
                  : fetchTeamLRequest
              }
              setApproveModal={setApproveModal}
              setHeading={setHeading}
            />
          </div>
        </div>

        <div
          className={`${rejectModal ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setRejectModal(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <RejectRequest
              leaveDays={leaveDays}
              selectedRowData={selectedRowData}
              setSuccess={setSuccess}
              fetchData={
                user.role === "1" || user.role === "4"
                  ? fetchLeaveRequest
                  : fetchTeamLRequest
              }
              setHeading={setHeading}
            />
          </div>
        </div>

        <div
          className={`${editModal ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setEditModal(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <EditRequest
              leaveDays={leaveDays}
              selectedRowData={selectedRowData}
              setSuccess={setSuccess}
              fetchData={
                user.role === "1" || user.role === "4"
                  ? fetchLeaveRequest
                  : fetchTeamLRequest
              }
              editModal={editModal}
              setEditModal={setEditModal}
              setHeading={setHeading}
            />
          </div>
        </div>

        <div
          className={`${revokeModal ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setRevokeModal(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <RevokeRequest
              leaveDays={leaveDays}
              selectedRowData={selectedRowData}
              setSuccess={setSuccess}
              fetchData={
                user.role === "1" || user.role === "4"
                  ? fetchLeaveRequest
                  : fetchTeamLRequest
              }
              revokeModal={revokeModal}
              setRevokeModal={setRevokeModal}
              setHeading={setHeading}
            />
          </div>
        </div>

        <div
          className={`${success ? "modal-overlay success-modal-overlay" : ""}`}
          onClick={() => {
            setSuccess(false);
          }}
        >
          <div onClick={(e) => e.stopPropagation()}>
            <Success heading={heading} para="" redirect="/leaveRequest" />
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaveRequest;
